import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tittle"
}
const _hoisted_2 = {
  key: 1,
  class: "file-type-chips"
}
const _hoisted_3 = { class: "file-loader" }
const _hoisted_4 = { class: "button-container" }
const _hoisted_5 = { class: "config-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StorageStatusInformation = _resolveComponent("StorageStatusInformation")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_TranslationConfig = _resolveComponent("TranslationConfig")!
  const _component_FileUploadPrompt = _resolveComponent("FileUploadPrompt")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_StorageStatusInformation, { documnetsCount: _ctx.documentCount }, null, 8, ["documnetsCount"]),
    _createElementVNode("div", null, [
      (!_ctx.uploadDisabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.tittle), 1))
        : _createCommentVNode("", true),
      (!_ctx.uploadDisabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileTypeChips, (chip) => {
              return (_openBlock(), _createBlock(_component_el_badge, {
                key: chip.color,
                value: _ctx.$t('fileUpload.new'),
                hidden: !chip.isNew
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tag, {
                    color: chip.color,
                    effect: "dark",
                    class: "file-type-chip"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(chip.ext), 1)
                    ]),
                    _: 2
                  }, 1032, ["color"])
                ]),
                _: 2
              }, 1032, ["value", "hidden"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_upload, {
          id: "file-upload",
          ref: "upload",
          action: "#",
          "auto-upload": false,
          accept: _ctx.acceptedTypes.join(','),
          disabled: _ctx.uploadDisabled,
          "on-change": _ctx.handleFileChange,
          "on-remove": _ctx.handleFileRemove,
          limit: 1,
          "file-list": _ctx.fileList
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_button, {
                type: "primary",
                disabled: _ctx.uploadDisabled || !_ctx.submitDisabled
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('fileUpload.selectFile')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _: 1
        }, 8, ["accept", "disabled", "on-change", "on-remove", "file-list"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_TranslationConfig, {
          modelValue: _ctx.configuration,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.configuration) = $event)),
          pageNamePrefix: _ctx.$t('fileUpload.configurationPrefix'),
          expended: true,
          readOptionsConfigEditable: true,
          documentType: _ctx.documentType,
          onConfigChanged: _ctx.saveConfig
        }, null, 8, ["modelValue", "pageNamePrefix", "documentType", "onConfigChanged"])
      ]),
      _createVNode(_component_FileUploadPrompt, {
        submitDisabled: _ctx.submitDisabled,
        onSubmitted: _ctx.submitFile
      }, null, 8, ["submitDisabled", "onSubmitted"])
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}